import React, { useEffect, useState } from "react";
import { LoaderComponent } from "../../component/LoaderComponent";
import {
  agentDataSelected,
  intersubcatSelected,
} from "../../Redux/IntermediaryReducer";
import { typeOfCalculator } from "../../Redux/InsurerReducer";
import Tree from "../../assets/images/vector-smart-object-copy-7.png";
import { useNavigate } from "react-router-dom";
import { typeOfCal } from "../../Constant";
import { useIsMobile } from "../../Hooks/useIsMobile";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { decryptResponse, doEncryption, refA_refB_ParentAgencyId } from "../../utilities/lib";

const EmployeeLogin = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const [showLoader, setShowLoader] = useState(false);
  const agentData = useSelector((state) => state.agData.agentData);
  const [employeeData, setemployeeData] = useState();
  const [refA, setRefA] = useState(agentData ? agentData.refA : "");
  const [refB, setRefB] = useState(agentData ? agentData.refB : "");
  const [refC, setRefC] = useState(agentData ? agentData.refC : "");
  const [disbaleRefs, setDisableRef] = useState({refADisable: false, refBDisable: false})
  
  const [employeeType, setEmployeeType] = useState(
    agentData ? agentData.businessFor : ""
  );
  //const [channel, setChannel] = useState(agentData ? agentData.businessFor === "partner" ? agentData.businesscreditchannel : agentData.channel :"" );
  const [channel, setChannel] = useState(agentData ? agentData.channel : "");
  const [parentagencyname, setParentAgencyName] = useState(
    agentData ? agentData.parentagencyname : ""
  );
  const [employeeAgentType, setEmployeeAgentType] = useState("");
  const [selectedBranchId, setSelectedBranchId] = useState(
    agentData ? agentData.branchId : ""
  );
  const [selectedEmployee, setSelectedEmployee] = useState(
    agentData ? agentData.agentName : ""
  );
  const [selectedEmployeeCode, setSelectedEmployeeCode] = useState(
    agentData ? agentData.agentId : ""
  );
  const [employeeTypeErr, setEmployeeTypeErr] = useState(false);
  const [channelErr, setChannelErr] = useState(false);
  const [parentagencynameErr, setParentAgencyNameErr] = useState(false);
  const [selectedBranchIdErr, setSelectedBranchIdErr] = useState(false);
  const [selectedEmployeeErr, setSelectedEmployeeErr] = useState(false);
  const [selectedEmployeeCodeErr, setSelectedEmployeeCodeErr] = useState(false);

  const getAllData = () => {
    setShowLoader(true);
    const reqObj = {
      agentid: props.paramsData.agentId,
      intermedsubcatcd: props.paramsData.intermedsubcatcd,
      mobilenumber: props.paramsData.mobilenumber,
    }
    var config = {
      method: "post",
      url: process.env.REACT_APP_Base_Url + "intermediary/v1/getiamdata",
      headers: {
        "Content-Type": "application/json",
      },
      data: doEncryption(reqObj)
    };

    axios(config)
      .then(function (res) {
        if (res.data.response?.length == 0) {
          return
        }
        let response = decryptResponse(res.data.response)
        response = JSON.parse(response);
        setemployeeData(response);
        if (refA_refB_ParentAgencyId.includes(response[0]?.parentagencyid)) {
          setDisableRef({ ...disbaleRefs, refADisable: response[0]?.refA?true:false, refBDisable: response[0]?.refB?true:false })
          setRefA(response[0]?.refA)
          setRefB(response[0]?.refB)
        }
        if (response.length) {
          let data = response[0];
          if (data) {
            data["businessFor"] = "self";
            data["flowType"] = "advisor";
            data["skip"] = props.paramsData.skip;
            data["authorization"] = props.paramsData.authorization;
            data["refA"] = "";
            data["refB"] = "";
            data["refC"] = "";
          }
          dispatch(agentDataSelected(data));
          dispatch(
            intersubcatSelected({
              agentid: props.paramsData.agentId,
              intermedsubcatcd: props.paramsData.intermedsubcatcd,
            })
          );
          if (props.paramsData.productName === "All Products") {
            navigate("/plan-selection");
          } else if (props.paramsData.productName === "Prohealth Prime") {
            navigate("/prohealth-prime");
            dispatch(typeOfCalculator(typeOfCal.prohealthPrime));
          } else if (props.paramsData.productName === "Lifetime Health") {
            navigate("/lifetime-health");
            dispatch(typeOfCalculator(typeOfCal.lifetime));
          } else if (props.paramsData.productName === "Prime Senior") {
            navigate("/prime-senior");
            dispatch(typeOfCalculator(typeOfCal.primeSenior));
          } else if (props.paramsData.productName === "Prohealth") {
            navigate("/prohealth-insurance");
            dispatch(typeOfCalculator(typeOfCal.prohealth));
          } else if (props.paramsData.productName === "Super Top Up") {
            navigate("/super-top-up");
            dispatch(typeOfCalculator(typeOfCal.superTopUp));
          } else if (props.paramsData.productName === "Critical Illness") {
            navigate("/critical-illness");
            dispatch(typeOfCalculator(typeOfCal.ci));
          } else if (props.paramsData.productName === "Personal Accident") {
            navigate("/personal-accident");
            dispatch(typeOfCalculator(typeOfCal.pa));
          } else if (props.paramsData.productName === "Accident Shield") {
            navigate("/accident-shield");
            dispatch(typeOfCalculator(typeOfCal.accident_Shield));
          } else if (props.paramsData.productName === "Sarvah") {
            navigate("/sarvah");
            dispatch(typeOfCalculator(typeOfCal.mchiSarvah));
          } else if (props.paramsData.productName === "Infinix") {
            navigate("/infinix");
            dispatch(typeOfCalculator(typeOfCal.infinix));
          }
        }
        //response.data.response[0].businesscreditchannel = 325
        const businesscreditchannel1 =
          response[0].businesscreditchannel == "750" ||
          response[0].businesscreditchannel == "350" ||
          response[0].businesscreditchannel == "312";
        const businesscreditchannel2 =
          response[0].businesscreditchannel == "325" ||
          response[0].businesscreditchannel == "375";

        // setEmployeeType(
        //   businesscreditchannel1 || businesscreditchannel2 ? "partner" : "self"
        // );
        setEmployeeType("self");
        setEmployeeAgentType(businesscreditchannel2);
        setShowLoader(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const checkValidFields = () => {
    let errors = {};
    if (employeeType === "partner") {
      if (!employeeType) {
        setEmployeeTypeErr(true);
        errors["employeeType"] = true;
      }
      if (!channel) {
        setChannelErr(true);
        errors["channel"] = true;
      }
      if (!parentagencyname) {
        setParentAgencyNameErr(true);
        errors["parentagencyname"] = true;
      }
      if (!selectedBranchId) {
        setSelectedBranchIdErr(true);
        errors["selectedBranchId"] = true;
      }
      if (!selectedEmployee) {
        setSelectedEmployeeErr(true);
        errors["selectedEmployee"] = true;
      }
      if (!selectedEmployeeCode) {
        setSelectedEmployeeCodeErr(true);
        errors["selectedEmployeeCode"] = true;
      }
    } else {
      if (!employeeType) {
        setEmployeeTypeErr(true);
        errors["employeeType"] = true;
      }
      if (!channel) {
        setChannelErr(true);
        errors["channel"] = true;
      }
    }
    if (Object.keys(errors).length > 0) {
      return true;
    } else {
      return false;
    }
  };
  const onNextClick = () => {
    if (checkValidFields()) {
      return;
    }
    var data = "";
    if (employeeType === "partner") {
      data = employeeData.find(
        (employeeData) => employeeData.agentName == selectedEmployee
      );
    } else {
      data = {
        agentId: employeeData && employeeData[0].employeeCodeOrSPCode,
        agentName: employeeData && employeeData[0].employeeNameOrSPName,
        channel: employeeData && employeeData[0].channel,
        mobileNo: "",
        emailIId: "",
        branchId: "",
        employeeCodeOrSPCode: "",
        employeeNameOrSPName: "",
        parentagencyname: employeeData && employeeData[0].parentagencyname,
        mappedirdalocation: employeeData && employeeData[0].mappedirdalocation,
        businesscreditchannel: "",
        pan: "",
        parentagencyid: employeeData && employeeData[0].parentagencyid,
      };
    }

    if (data) {
      data["businessFor"] = employeeType;
      data["flowType"] = "advisor";
      data["skip"] = false;
      data["refA"] = refA;
      data["refB"] = refB;
      data["refC"] = refC;
    }
    dispatch(agentDataSelected(data));
    if (props.paramsData.productName === "All Products") {
      navigate("/plan-selection");
    } else if (props.paramsData.productName === "Prohealth Prime") {
      navigate("/prohealth-prime");
      dispatch(typeOfCalculator(typeOfCal.prohealthPrime));
    } else if (props.paramsData.productName === "Lifetime Health") {
      navigate("/lifetime-health");
      dispatch(typeOfCalculator(typeOfCal.lifetime));
    } else if (props.paramsData.productName === "Prime Senior") {
      navigate("/prime-senior");
      dispatch(typeOfCalculator(typeOfCal.primeSenior));
    } else if (props.paramsData.productName === "Prohealth") {
      navigate("/prohealth-insurance");
      dispatch(typeOfCalculator(typeOfCal.prohealth));
    } else if (props.paramsData.productName === "Super Top Up") {
      navigate("/super-top-up");
      dispatch(typeOfCalculator(typeOfCal.superTopUp));
    } else if (props.paramsData.productName === "Critical Illness") {
      navigate("/critical-illness");
      dispatch(typeOfCalculator(typeOfCal.ci));
    } else if (props.paramsData.productName === "Personal Accident") {
      navigate("/personal-accident");
      dispatch(typeOfCalculator(typeOfCal.pa));
    } else if (props.paramsData.productName === "Accident Shield") {
      navigate("/accident-shield");
      dispatch(typeOfCalculator(typeOfCal.accident_Shield));
    } else if (props.paramsData.productName === "Sarvah") {
      navigate("/sarvah");
      dispatch(typeOfCalculator(typeOfCal.mchiSarvah));
    } else if (props.paramsData.productName === "Infinix") {
      navigate("/infinix");
      dispatch(typeOfCalculator(typeOfCal.infinix));
    }
  };

  useEffect(() => {
    getAllData();
  }, []);

  const arrayBranchIds =
    employeeData &&
    employeeData.length > 0 &&
    employeeData.map((src, index) => {
      return (
        <option key={index} value={src.branchId}>
          {src.branchId}
        </option>
      );
    });

  const arrayFilteredEmployeeDetails =
    employeeData &&
    employeeData.length > 0 &&
    employeeData.find(
      (employeeData) => employeeData.branchId == selectedBranchId
    );

  const arrayAgentNames =
    employeeData &&
    employeeData.length > 0 &&
    employeeData.map((src, index) => {
      return (
        <option key={index} value={src.agentName}>
          {src.agentName}
        </option>
      );
    });

  const arrayAgentCodes =
    employeeData &&
    employeeData.length > 0 &&
    employeeData.find(
      (employeeData) => employeeData.agentName == selectedEmployee
    );

  /**     const uniqueEmployeeSPNamesList = employeeData &&
    employeeData.length > 0 && [
      ...new Map(employeeData.map((m) => [m.agentName, m])).values(),
    ];
  
  const arrayEmployeeSPNames =
    uniqueEmployeeSPNamesList &&
    uniqueEmployeeSPNamesList.length > 0 &&
    uniqueEmployeeSPNamesList.map((src, index) => {
      return (
        <option key={index} value={src.agentName}>
          {src.agentName}
        </option>
      );
    });

  const unique = arrayEmployeeSPNames &&
    arrayEmployeeSPNames.length > 0 && [
      ...new Map(arrayEmployeeSPNames.map((m) => [m.value, m])).values(),
    ]; */

  const handleEmployeeTypeChange = (value) => {
    const employeeType = value == "self" ? "self" : "partner";
    setEmployeeType(employeeType);
  };

  const handleChannelChange = (value) => {
    setChannel(value);
  };

  const handlePartnerAgencyName = (value) => {
    setParentAgencyName(value);
  };

  const handleSelectedBrandId = (value) => {
    setSelectedBranchId(value);
    setSelectedEmployee("");
    setSelectedEmployeeCode("");
  };

  const handleSelectedEmployee = (value) => {
    setSelectedEmployee(value);
    setSelectedEmployeeCode("");
  };

  const handleSelectedEmployeeCode = (value) => {
    setSelectedEmployeeCode(value);
  };

  return (
    <>
      {showLoader && <LoaderComponent />}
      <div className="App">
        <div className="bg_blue mt-5">
          <div className="row mt-5">
            <div
              className={
                isMobile ? "col-md-12 p-0 text-center" : "col-md-12 p-0"
              }
            >
              <div
                class={isMobile ? "jumbotron" : "jumbotron pt-3 p-4 mt-5"}
                style={{ marginTop: `${isMobile ? "80px" : "0px"}` }}
              >
                <h3 class="text-white">
                  Welcome {employeeData && employeeData[0].employeeNameOrSPName}
                </h3>
                <p className="text-white">
                  DMS Code -{" "}
                  {employeeData && employeeData[0].employeeCodeOrSPCode}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg_light_blue mt-4">
          <div className="container mt-5">
            <div className="row" style={{ marginTop: "-100px" }}>
              {/* <div className="col-md-3">
                <div className="card p-5 bg-orange ">
                  <div className="mb-2">
                    <label className="mb-2">
                      Employee DMS Name
                      <i className="text-white">*</i>
                    </label>
                    <h6 class="card-subtitle mb-2">
                      {employeeData && employeeData[0].employeeNameOrSPName}
                    </h6>
                  </div>
                  <div className="mb-2">
                    <label className="mb-2">
                      Employee DMS Code
                      <i className="text-white">*</i>
                    </label>
                    <h6 class="card-subtitle mb-2">
                      {employeeData && employeeData[0].employeeCodeOrSPCode}
                    </h6>
                  </div>
                  <div className="mb-2">
                    <label className="mb-2">MCHI Branch Code</label>
                    <h6 class="card-subtitle mb-2">
                      {employeeData && employeeData[0].mappedirdalocation}
                    </h6>
                  </div>
                </div>
              </div> */}
              <div>
                <div className="card p-4">
                  <div class="container" style={{ display: "grid" }}>
                    <div class="row">
                      <div class="col-md-4 p-3">
                        <div className="input_icon form-group label_mid">
                          <label className="mb-1">
                            <b>Business Sourced</b>
                            <i className="red">*</i>
                          </label>
                          <select
                            class="form-select"
                            aria-label="Default select example"
                            value={employeeType}
                            onChange={(e) =>
                              handleEmployeeTypeChange(e.target.value)
                            }
                          >
                            <option selected hidden>
                              Select
                            </option>
                            <option value="self">Self</option>
                            {/* <option value="partner">Partner</option> */}
                          </select>
                        </div>
                        <div id="name-error" className="error font_12 red">
                          {!employeeType &&
                            employeeTypeErr &&
                            "Please enter Business Sourced"}
                        </div>
                      </div>
                      <div class="col-md-4 p-3">
                        <div className="input_icon form-group label_mid">
                          <label className="mb-1">
                            <b>Channel</b>
                            <i className="red">*</i>
                          </label>
                          <select
                            class="form-select"
                            aria-label="Default select example"
                            value={channel}
                            onChange={(e) =>
                              handleChannelChange(e.target.value)
                            }
                          >
                            <option hidden selected>
                              Select
                            </option>
                            {employeeType == "self" ? (
                              <option
                                value={employeeData && employeeData[0].channel}
                              >
                                {employeeData && employeeData[0].channel}
                              </option>
                            ) : (
                              <option
                                value={
                                  employeeData &&
                                  employeeData[0].businesscreditchannel
                                }
                              >
                                {employeeData &&
                                  employeeData[0].businesscreditchannel}
                              </option>
                            )}
                          </select>
                        </div>
                        <div id="name-error" className="error font_12 red">
                          {!channel && channelErr && "Please enter Channel"}
                        </div>
                      </div>
                      {employeeType == "partner" && !employeeAgentType && (
                        <>
                          <div class="col-md-4 p-3">
                            <div className="input_icon form-group label_mid">
                              <label className="mb-1">
                                <b>Partner Name</b>
                                <i className="red">*</i>
                              </label>
                              <select
                                class="form-select"
                                aria-label="Default select example"
                                value={parentagencyname}
                                onChange={(e) =>
                                  handlePartnerAgencyName(e.target.value)
                                }
                              >
                                <option hidden selected>
                                  Select
                                </option>
                                <option value="1">
                                  {employeeData &&
                                    employeeData[0].parentagencyname}
                                </option>
                              </select>
                            </div>
                            <div id="name-error" className="error font_12 red">
                              {!parentagencyname &&
                                parentagencynameErr &&
                                "Please enter Partner Name"}
                            </div>
                          </div>
                          <div class="col-md-4 p-3">
                            <div className="input_icon form-group label_mid">
                              <label className="mb-1">
                                <b>Partner Branch Code</b>
                                <i className="red">*</i>
                              </label>
                              <select
                                onChange={(e) =>
                                  handleSelectedBrandId(e.target.value)
                                }
                                value={selectedBranchId}
                                class="form-select"
                                aria-label="Default select example"
                              >
                                <option hidden selected>
                                  Select
                                </option>
                                {arrayBranchIds}
                              </select>
                            </div>
                            <div id="name-error" className="error font_12 red">
                              {!selectedBranchId &&
                                selectedBranchIdErr &&
                                "Please enter Partner Branch Code"}
                            </div>
                          </div>{" "}
                        </>
                      )}
                      <div class="col-md-4"></div>
                    </div>
                    {employeeType == "partner" && (
                      <div class="row">
                        <div class="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              {employeeAgentType ? (
                                <b>Agent/IMF Name</b>
                              ) : (
                                <b>SP Name</b>
                              )}
                              <i className="red">*</i>
                            </label>
                            <select
                              class="form-select"
                              aria-label="Default select example"
                              onChange={(e) =>
                                handleSelectedEmployee(e.target.value)
                              }
                              value={selectedEmployee}
                            >
                              <option hidden selected>
                                Select
                              </option>
                              {employeeAgentType
                                ? employeeData &&
                                  employeeData.map((src, index) => {
                                    return (
                                      <option key={index} value={src.agentName}>
                                        {src.agentName}
                                      </option>
                                    );
                                  })
                                : arrayFilteredEmployeeDetails && (
                                    <option>
                                      {arrayFilteredEmployeeDetails.agentName}
                                    </option>
                                  )}
                            </select>
                          </div>
                          <div id="name-error" className="error font_12 red">
                            {!selectedEmployee &&
                              selectedEmployeeErr &&
                              "Please enter SP Name"}
                          </div>
                        </div>
                        <div class="col-md-4 p-3">
                          <div className="input_icon form-group label_mid">
                            <label className="mb-1">
                              {employeeAgentType ? (
                                <b>Agent/IMF Code</b>
                              ) : (
                                <b>SP Code</b>
                              )}
                              <i className="red">*</i>
                            </label>
                            <select
                              class="form-select"
                              aria-label="Default select example"
                              onChange={(e) =>
                                handleSelectedEmployeeCode(e.target.value)
                              }
                              value={selectedEmployeeCode}
                            >
                              <option hidden selected>
                                Select
                              </option>
                              {employeeAgentType
                                ? arrayAgentCodes && (
                                    <option>{arrayAgentCodes.agentId}</option>
                                  )
                                : arrayFilteredEmployeeDetails && (
                                    <option>
                                      {arrayFilteredEmployeeDetails.agentId}
                                    </option>
                                  )}
                            </select>
                          </div>
                          <div id="name-error" className="error font_12 red">
                            {!selectedEmployeeCode &&
                              selectedEmployeeCodeErr &&
                              "Please enter SP Code"}
                          </div>
                        </div>
                      </div>
                    )}
                    <div class="row">
                      <div class="col-md-4 p-3">
                        <label className="mb-1">
                          <b>Ref A {businesscreditchannel1=="750"?"(Sol Id / Partner Code) 1":""}</b>
                        </label>
                        <textarea
                          class="form-control"
                          placeholder="Give description here"
                          id="floatingTextarea"
                          value={refA}
                          disabled={disbaleRefs.refADisable}
                          readOnly={disbaleRefs.refADisable}
                          {...(!disbaleRefs.refADisable && ({
                            onChange: (e) => setRefA(e.target.value)
                          }))}
                        ></textarea>
                      </div>
                      <div class="col-md-4 p-3">
                        <label className="mb-1">
                          <b>Ref B {businesscreditchannel1=="750"?"(LG Code)":""}</b>
                        </label>
                        <textarea
                          class="form-control"
                          placeholder="Give description here"
                          id="floatingTextarea"
                          value={refB}
                          disabled={disbaleRefs.refBDisable}
                          readOnly={disbaleRefs.refBDisable}
                          {...(!disbaleRefs.refBDisable && ({
                            onChange: (e) => setRefB(e.target.value)
                          }))}
                        ></textarea>
                      </div>
                      <div class="col-md-4 p-3">
                        <label className="mb-1">
                          <b>Ref C {businesscreditchannel1=="750"?"(FLS DMS Code)":""}</b>
                        </label>
                        <textarea
                          class="form-control"
                          placeholder="Give description here"
                          id="floatingTextarea"
                          value={refC}
                          onChange={(e) => setRefC(e.target.value)}
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ background: "#f5f5f5" }}>
          <div className="fixed mt-3">
            <div className="row">
              <div className="col-6">
                <img
                  src={Tree}
                  alt="vector-smart-object-copy-7"
                  className="tree-image"
                />
              </div>
              <div className="col-6 text-right" style={{ top: "45px" }}>
                <button
                  onClick={() => onNextClick()}
                  className="btn btn-primary-custom"
                >
                  NEXT &nbsp;
                  <i className="fa fa-angle-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeLogin;
